import { useState } from "react";
import { Link } from "react-router-dom";
import { suppliers, supplierCategories } from "@/mocks/suppliers";

const SupplierSection = () => {
  const [activeCategory, setActiveCategory] = useState("All");

  const filtered = activeCategory === "All"
    ? suppliers
    : suppliers.filter((s) => s.category === activeCategory);

  return (
    <section id="suppliers" className="py-16 bg-[#fdf8f8]">
      <div className="max-w-[1400px] mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <div className="w-10 h-1 bg-[#C41E3A] rounded-full"></div>
              <span className="text-[#C41E3A] text-sm font-semibold uppercase tracking-wider">Direct from Factory</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900">
              Verified Factory and Farm Suppliers Made in USA
            </h2>
            <p className="text-gray-500 mt-2 text-sm">
              Source directly from certified manufacturers. Competitive wholesale prices for USA &amp; Canada buyers.
            </p>
          </div>
          <a
            href="#contact"
            className="flex items-center gap-2 bg-[#C41E3A] text-white px-5 py-2 rounded-full text-sm font-semibold hover:bg-[#a01830] transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-building-2-line"></i> Become a Supplier
          </a>
        </div>

        {/* Category Tabs */}
        <div className="flex flex-wrap gap-2 mb-8">
          {supplierCategories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                activeCategory === cat
                  ? "bg-[#C41E3A] text-white"
                  : "bg-white text-gray-600 border border-gray-200 hover:border-[#C41E3A] hover:text-[#C41E3A]"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Supplier Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {filtered.map((supplier) => (
            <div
              key={supplier.id}
              className="bg-white rounded-lg overflow-hidden border border-gray-100 hover:border-[#C41E3A] transition-all duration-300 group cursor-pointer"
            >
              {/* Image */}
              <div className="relative h-44 overflow-hidden">
                <img
                  src={supplier.image}
                  alt={supplier.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-3 right-3 bg-[#D4AF37] text-white text-[10px] font-bold px-2 py-1 rounded-full">
                  {supplier.badge}
                </div>
                {supplier.verified && (
                  <div className="absolute top-3 left-3 bg-[#C41E3A] text-white text-[10px] font-bold px-2 py-1 rounded-full flex items-center gap-1">
                    <i className="ri-shield-check-line"></i> Verified
                  </div>
                )}
              </div>

              {/* Info */}
              <div className="p-4">
                <h3 className="font-bold text-gray-900 text-sm mb-1 leading-tight">{supplier.name}</h3>
                <div className="flex items-center gap-1 text-gray-400 text-xs mb-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-map-pin-line"></i>
                  </div>
                  {supplier.location}
                </div>
                <div className="flex items-center gap-1 mb-3">
                  {[...Array(5)].map((_, i) => (
                    <div key={i} className="w-3 h-3 flex items-center justify-center">
                      <i className={i < Math.floor(supplier.rating) ? "ri-star-fill text-[#D4AF37] text-xs" : "ri-star-line text-[#D4AF37] text-xs"}></i>
                    </div>
                  ))}
                  <span className="text-xs text-gray-500 ml-1">{supplier.rating} ({supplier.reviews})</span>
                </div>
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <div className="text-[10px] text-gray-400">Min. Order</div>
                    <div className="text-sm font-bold text-[#C41E3A]">{supplier.minOrder}</div>
                  </div>
                  <div className="text-xs text-gray-400 bg-gray-50 px-2 py-1 rounded">{supplier.category}</div>
                </div>
                <div className="flex gap-2">
                  <a
                    href="https://wa.me/1234567890"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1 flex items-center justify-center gap-1 bg-[#25D366] text-white text-xs py-2 rounded-md font-semibold hover:bg-[#1ebe5d] transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-whatsapp-line"></i> WhatsApp
                  </a>
                  <button className="flex-1 flex items-center justify-center gap-1 bg-[#C41E3A] text-white text-xs py-2 rounded-md font-semibold hover:bg-[#a01830] transition-colors cursor-pointer whitespace-nowrap">
                    <i className="ri-message-3-line"></i> CrownChat
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* View All */}
        <div className="text-center mt-10">
          <Link
            to="/products"
            className="inline-block border-2 border-[#C41E3A] text-[#C41E3A] px-8 py-3 rounded-full font-semibold hover:bg-[#C41E3A] hover:text-white transition-colors cursor-pointer whitespace-nowrap"
          >
            Browse All Products
          </Link>
        </div>
      </div>
    </section>
  );
};

export default SupplierSection;
